<template>
  <div id="app">
    <div class="container-fluid main-container">
      <!-- <Header v-if="visibleHeader" /> -->
      <PwaInstall />
      <router-view></router-view>
      <div class="app-credit">
        Developed by
        <a
          href="https://speedcodelabs.com/"
          target="_blank"
          rel="noopener noreferrer"
        >SpeedCodeLabs</a>
      </div>
      <ActionButton v-if="showActionButton" />
    </div>
  </div>
</template>

<script>
import { Header } from "@/components/index.js";
import ActionButton from "../src/components/Share/ActionButton/index";
import PwaInstall from "@/components/Share/PwaInstall/index.vue";
import { getValidToken } from "@/utils/auth";


export default {
  components: {
    Header, ActionButton, PwaInstall
  },
  created() {
    if (getValidToken()) {
      this.$store.dispatch('organization/fetchOrganization');
      this.$store.dispatch('sitesetting/GetSettings').catch(() => {});
      this.$store.dispatch('auth/fetchUserInfo').catch(() => {});
    }
  },
  computed: {
    showActionButton() {
      const path = this.$route.path;
      return path !== "/login" && path !== "/kitchen/login";
    },
    visibleHeader: function () {
      if (this.$route.path == "/login") {
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
:root {
  --app-footer-height: 28px;
}

html,
body,
#app {
  font-family: "Poppins", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
  min-height: 100vh;
}

html.kot-pwa-banner #app .main-container {
  padding-top: 88px !important;
}

html.kot-pwa-standalone body {
  padding-top: env(safe-area-inset-top);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
}

#app {
  // font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #1e293b;
  min-height: 100vh;

  .main-container {
    min-height: 100vh;
    top: 0;
    padding: 0 0 var(--app-footer-height) !important;
    box-sizing: border-box;
  }
}

.app-credit {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 30;
  height: var(--app-footer-height);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
  font-size: 11px;
  line-height: 1;
  color: #64748b;
}

.app-credit a {
  color: #058397 !important;
  font-weight: 700;
  text-decoration: none;
}

.app-credit a:hover {
  text-decoration: underline;
}

html.kot-dark .app-credit {
  background: #1a242c;
  color: #d5dee6 !important;
  border-top-color: rgba(255, 255, 255, 0.16);
}

html.kot-dark .app-credit a {
  color: #7dd3e0 !important;
}

nav.float-action-button {
  bottom: var(--app-footer-height) !important;
  z-index: 40;
}

@media (max-width: 767px) {
  html.kot-pwa-banner #app .main-container {
    padding-top: 156px !important;
  }
}
</style>
